class UserStorage {
  constructor() {
    this.LOCAL_STORAGE_USER = "user-info";
    this.LOCAL_STORAGE_LINE_TOKEN = "line-token-regis"
    this.LOCAL_STORAGE_LINE_FRIEND_TOKEN = "line-add-friend-token"
  }

  get userInfo() {
    return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_USER));
  }
  get userLineToken() {
    return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_LINE_TOKEN));
  }
  get userLineFriendToken() {
    return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_LINE_FRIEND_TOKEN));
  }

  set userInfo(data) {
    localStorage.setItem(this.LOCAL_STORAGE_USER, JSON.stringify(data));
  }
  set userLineToken(data) {
    localStorage.setItem(this.LOCAL_STORAGE_LINE_TOKEN, JSON.stringify(data));
  }
  set userLineFriendToken(data) {
    localStorage.setItem(this.LOCAL_STORAGE_LINE_FRIEND_TOKEN, JSON.stringify(data));
  }

  clear() {
    localStorage.removeItem(this.LOCAL_STORAGE_USER)
  }
  clearLineFriendToken() {
    localStorage.removeItem(this.LOCAL_STORAGE_LINE_FRIEND_TOKEN)
  }

}

export default new UserStorage();